export enum QATypeCode {
  QA = "QA",
}
